import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ConditionalWrapper, LinkButton, TextAlpha, useMediaQueryMatchesOnDesktop } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { ScrollUtil } from '../../../../util/ScrollUtil';
import { makeGetBasketMappedProductsState } from '../../../../redux/basket/selectors/BasketSelector';
export const CheckoutDisabledMessage = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const products = useSelector(makeGetBasketMappedProductsState());
    const scrollToStoreSourceExcludedProduct = () => {
        const firstSSEProductIndex = products.findIndex(product => (product.sseProduct && !product.availableInSSEStore) ||
            (product.specialtyStoreProduct && !product.availableInSpecialtyStore));
        const element = document.querySelectorAll('[data-testid^="basket-product-tile-"]')[firstSSEProductIndex];
        ScrollUtil.scrollToElement(element, true, 'center');
    };
    return (_jsxs(TextAlpha, { color: "error", variant: "bodyS", children: [t('product.store.source.excluded.general'), _jsx(ConditionalWrapper, { condition: !isDesktop, wrapper: children => (_jsxs(_Fragment, { children: [' ', _jsx(LinkButton, { size: "sm", text: children, onClick: scrollToStoreSourceExcludedProduct })] })), children: t('product.store.source.excluded.edit.part2') }), t('product.store.source.excluded.edit.part3')] }));
};
